<div
  class="card card-template-c"
  [ngClass]="[padding ? 'pd-' + padding : '', 'shadow-' + shadow, 'border-' + borderStyle, background]"
>
  <ng-content></ng-content>
</div>
